module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "carouselContainer",
    staticClass: "carousel-container",
    on: {
      "click": function($event) {
        _vm.closeCarousel()
      }
    }
  }, [_c('section', {
    ref: "contentContainer",
    staticClass: "carousel-content-container"
  }, _vm._l((_vm.cards), function(card, i) {
    return _c('div', {
      key: i,
      class: ['carousel-card-container', {
        'carousel-card-container--active': _vm.Xcursor == i
      }],
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleCard()
        }
      }
    }, [(_vm.type == 'card') ? _c('folded-card', {
      class: ['carousel-card', {
        'carousel-card--active': i == _vm.Xcursor
      }],
      attrs: {
        "is-open": i == _vm.Xcursor && _vm.isOpen,
        "orientation": card.orientation
      }
    }, [_c('img', {
      staticClass: "cover-image",
      attrs: {
        "slot": "cover-front",
        "src": ("assets/cards/" + (card.name) + "/cover.png")
      },
      slot: "cover-front"
    }), _vm._v(" "), _c('img', {
      staticClass: "content-image",
      attrs: {
        "slot": "backing-front",
        "src": ("assets/cards/" + (card.name) + "/contents.png")
      },
      slot: "backing-front"
    })]) : _vm._e(), _vm._v(" "), (_vm.type == 'photo') ? _c('photo-card', {
      class: ['carousel-card', {
        'carousel-card--active': i == _vm.Xcursor
      }],
      attrs: {
        "is-flipped": i == _vm.Xcursor && _vm.isOpen,
        "orientation": card.orientation
      }
    }, [_c('img', {
      staticClass: "cover-image",
      attrs: {
        "slot": "card-front",
        "src": ("assets/cards/photos/" + (card.name) + ".jpg")
      },
      slot: "card-front"
    }), _vm._v(" "), _c('img', {
      staticClass: "content-image",
      attrs: {
        "slot": "card-back",
        "src": ("assets/cards/photo-backs/" + (card.name) + "-back.jpg")
      },
      slot: "card-back"
    })]) : _vm._e()], 1)
  })), _vm._v(" "), _c('nav', {
    staticClass: "carousel-nav-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeCard()
      }
    }
  }, [_c('button', {
    staticClass: "carousel-nav-control carousel-prev-control",
    attrs: {
      "disabled": !_vm.hasPrevious
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.previous()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "carousel-nav-index"
  }, [_vm._v("Card " + _vm._s(_vm.Xcursor + 1) + " of " + _vm._s(_vm.cards.length))]), _vm._v(" "), _c('button', {
    staticClass: "carousel-nav-control carousel-next-control",
    attrs: {
      "disabled": !_vm.hasNext
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.next()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64147323","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/carousel.vue
// module id = 36
// module chunks = 0